function init() {
	let $slider = $('.js-slider');
	let $sliderMulti = $('.js-slider-multi');
	let $zoomBtn = $('.js-slider-item-zoom');

	if ($slider.length) {
		$slider.each((index, slider) => {
			let $slider = $(slider);
			let $sliderParrent = $slider.closest('.slider');
			let $sliderPrev = $sliderParrent.find('.js-slider-prev');
			let $sliderNext = $sliderParrent.find('.js-slider-next');
			let $sliderCurrent = $sliderParrent.find('.js-slider-current');
			// let $sliderTotal = $sliderParrent.find('.js-slider-total');

			// $sliderTotal.text($slider.find('> div').length);
			// console.log($slider.parent().find('.slick-dots-wrapper'));

			$slider.slick({
				dots: true,
				infinite: false,
				slidesToShow: 1,
				lazyLoad: 'ondemand',
				variableWidth: true,
				focusOnSelect: true,
				appendDots: $slider.parent().find('.slick-dots-wrapper'),
				prevArrow: $sliderPrev,
				nextArrow: $sliderNext,
			});

			$slider.on('afterChange', (slick, currentSlide) => {
				$sliderCurrent.text(currentSlide.currentSlide + 1);

				$(document).trigger('slider-change');
			});

			$slider.closest('.slider').removeClass('is-hidden');

			// if ( $slider.find('.js-slider-item-zoom').length == 1 ) {
			// 	console.log('Slider has Zoom.');
			// }
		});
	}

	// if ($sliderMulti.length) {
	// 	$sliderMulti.each((index, slider) => {
	// 		let $slider = $(slider);
	// 		let $sliderParrent = $slider.closest('.slider');
	// 		let $sliderPrev = $sliderParrent.find('.js-slider-prev');
	// 		let $sliderNext = $sliderParrent.find('.js-slider-next');
	// 		let $sliderCurrent = $sliderParrent.find('.js-slider-current');
	// 		// let $sliderTotal = $sliderParrent.find('.js-slider-total');

	// 		// $sliderTotal.text($slider.find('> div').length);

	// 		$slider.slick({
	// 			dots: true,
	// 			infinite: false,
	// 			slidesToShow: 1,
	// 			focusOnSelect: true,
	// 			lazyLoad: 'ondemand',
	// 			prevArrow: $sliderPrev,
	// 			nextArrow: $sliderNext,
	// 		});

	// 		$slider.on('afterChange', (slick, currentSlide) => {
	// 			$sliderCurrent.text(currentSlide.currentSlide + 1);

	// 			$(document).trigger('slider-change');
	// 		});
	// 	});
	// }

	// let zoomModal = $('.modal[data-modal-id="zoom"]');
	// console.log(zoomModal);

	// $($zoomBtn).each(function(index) {
	// 	$(this).on("click", function(e) {
	// 		let img = $(this).parent().find('img');
	// 		console.log(img);

	// 		let src = $(img).attr('src');
	// 		console.log(src);

	// 		zoomModal.find('img').attr('src', src);
	// 	});
	// });

}

export default {
	init,
};
